import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify';
import './registerServiceWorker'
import vueComponentsSetup from './setups/vueComponentsSetup.js'
import vuePrototypesSetup from './setups/vuePrototypesSetup.js'
import i18n from "./plugins/i18n.js"

import VueCountdownTimer from 'vuejs-countdown-timer';
Vue.use(VueCountdownTimer);

import VuePlayer from "@algoz098/vue-player"
Vue.component("vue-player", VuePlayer)

import VueRecord from '@codekraft-studio/vue-record'
Vue.use(VueRecord);

import Moment from 'moment'
Vue.use(Moment);

import VueSignature from "vue-signature-pad";
Vue.use(VueSignature);

import VueQuagga from 'vue-quaggajs';
Vue.use(VueQuagga);

import DatetimePicker from 'vuetify-datetime-picker'
Vue.use(DatetimePicker);

import vuescroll from 'vuescroll';
Vue.use(vuescroll, {});

import VueLocalForage from 'vue-localforage'
Vue.use(VueLocalForage)

import WebCam from 'vue-web-cam'

Vue.use(WebCam);

Vue.config.productionTip = false

vueComponentsSetup();

vuePrototypesSetup();

new Vue({
  router,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')



